import { Injectable } from '@angular/core';
import * as deviceUuid from 'device-uuid';
import { Md5 } from 'ts-md5';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  /**
   * Device Info and UUID
   * Unique UUID based on Browser name and device UUID
   * https://github.com/biggora/device-uuid/
   * https://github.com/cotag/ts-md5
   */
  deviceAndBrowserUuid = {
    uniqueUuid: String(Md5.hashStr(`${new deviceUuid.DeviceUUID().parse().browser}${new deviceUuid.DeviceUUID().get()}`))
  };
}
